import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = {
    updateUrl: { type: String, default: "" },
    markAllUrl: { type: String, default: "" }
  }

  static targets = ["badge"]

  markAsRead(event) {
    event.preventDefault()
    if (!this.updateUrlValue) return

    patch(this.updateUrlValue, {
      responseKind: "turbo-stream"
    }).then((response) => {
      if (response.ok) {
        this.decrementBadge()
        if (window.location.pathname === "/notifications") {
          window.location.reload()
        }
      }
    })
  }

  markAllAsRead(event) {
    event.preventDefault()
    if (!this.markAllUrlValue) return

    patch(this.markAllUrlValue, {
      responseKind: "turbo-stream"
    }).then((response) => {
      if (response.ok) {
        this.hideBadge()
        if (window.location.pathname === "/notifications") {
          window.location.reload()
        }
      }
    })
  }

  decrementBadge() {
    const el = this.badgeElement()
    if (!el) return
    let count = parseInt(el.dataset.notificationsUnreadCount, 10)
    if (Number.isNaN(count)) {
      const raw = el.textContent.trim()
      count = raw === "9+" ? 10 : parseInt(raw, 10)
    }
    if (Number.isNaN(count)) return

    count = Math.max(0, count - 1)
    el.dataset.notificationsUnreadCount = String(count)

    if (count === 0) {
      this.hideBadge()
    } else {
      el.textContent = count > 9 ? "9+" : String(count)
    }
  }

  hideBadge() {
    const el = this.badgeElement()
    if (el) el.classList.add("hidden")
  }

  badgeElement() {
    if (this.hasBadgeTarget) return this.badgeTarget

    return document.querySelector("[data-notifications-target='badge']")
  }
}
